<template>
    <div class="home">
        <div class="columns minh500">
            <div class="column is-2 bg-gray is-">
                <!-- ZONE RAPPEL -->
                <div class="columns is-multiline">
                    <div class="column is-half has-text-weight-bold has-text-left ml-2">
                        {{ $t('step0') }}<br/>
                        {{ $t('name') }}<br/>
                        <!-- TODO comment indiqué éveillé ou émergé -->
                        {{ $t('step2') }}<br/>
                        {{ $t('force') }}<br/>
                        {{ $t('agilite') }}<br/>
                        {{ $t('volonte') }}<br/>
                        {{ $t('logique') }}<br/>
                        {{ $t('charisme') }}<br/>
                        {{ $t('chance') }}<br/>
                        {{ $t('essence') }}<br/>
                        <!-- TODO Compétences ? -->
                        <!-- TODO Atouts ? -->
                        <!-- TODO Traits ? -->
                        <!-- TODO Contacts/Armure/Armes/équipement ? -->
                    </div>
                    <div class="column has-text-left ml-2">
                        <div v-if="activeStep > 0">
                            <div v-if="step0 == 1">{{ $t('step0level1') }}</div>
                            <div v-else-if="step0 == 2">{{ $t('step0level2') }}</div>
                            <div v-else-if="step0 == 3">{{ $t('step0level3') }}</div>
                        </div>
                        <div v-else></div>
                        <div v-if="activeStep > 1">{{ name }}<br/></div>
                        <div v-if="activeStep > 2">{{ $t(metatype) }}<br/></div>
                        <div v-if="activeStep > 3">
                            {{ force }}<br/>
                            {{ agilite }}<br/>
                            {{ volonte }}<br/>
                            {{ logique }}<br/>
                            {{ charisme }}<br/>
                            {{ chance }}<br/>
                        </div>
                        <div v-if="activeStep > 4">{{ essenceLeft }}</div>
                    </div>
                </div>
            </div>
            <div class="column is-10">
                <!-- STEPS -->
                <b-steps v-model="activeStep" :hasNavigation="false">
                    <b-step-item step="1" v-bind:label="$t('step0')" :clickable="true">
                        <b-field position="is-centered">
                            <b-radio-button v-model="step0" native-value="1" @input="countCalc()" type="is-success is-light is-outlined">
                                <span>{{ $t('step0level1') }}</span>
                            </b-radio-button>
                            <b-radio-button v-model="step0" native-value="2" @input="countCalc()" type="is-success is-light is-outlined">
                                <span>{{ $t('step0level2') }}</span>
                            </b-radio-button>
                            <b-radio-button v-model="step0" native-value="3" @input="countCalc()" type="is-success is-light is-outlined">
                                <span>{{ $t('step0level3') }}</span>
                            </b-radio-button>
                        </b-field>
                    </b-step-item>
                    <!-- STEP 2 CONCEPT -->
                    <b-step-item step="2" v-bind:label="$t('step1')" :clickable="true">
                        <b-field grouped>
                            <b-field v-bind:label="$t('name')" :label-position="labelPosition" class="is-flex-grow-1"><b-input v-model="name"/></b-field>
                            <b-field v-bind:label="$tc('comportement', 1) + ' 1'" :label-position="labelPosition" class="is-flex-grow-1"><b-input v-model="COMPORTEMENTS_1"/></b-field>
                            <b-field v-bind:label="$tc('comportement', 1) + ' 2'" :label-position="labelPosition" class="is-flex-grow-1"><b-input v-model="COMPORTEMENTS_2"/></b-field>
                            <b-field v-bind:label="$tc('comportement', 1) + ' 3'" :label-position="labelPosition" class="is-flex-grow-1"><b-input v-model="COMPORTEMENTS_3"/></b-field>
                            <b-field v-bind:label="$tc('comportement', 1) + ' 4'" :label-position="labelPosition" class="is-flex-grow-1"><b-input v-model="COMPORTEMENTS_4"/></b-field>
                        </b-field>
                        <b-field grouped>
                            <b-field v-bind:label="$tc('motcle', 1) + ' 1'" :label-position="labelPosition" class="is-flex-grow-1"><b-input v-model="MOTSCLÉS_1"/></b-field>
                            <b-field v-bind:label="$tc('motcle', 1) + ' 2'" :label-position="labelPosition" class="is-flex-grow-1"><b-input v-model="MOTSCLÉS_2"/></b-field>
                            <b-field v-bind:label="$tc('motcle', 1) + ' 3'" :label-position="labelPosition" class="is-flex-grow-1"><b-input v-model="MOTSCLÉS_3"/></b-field>
                            <b-field v-bind:label="$tc('motcle', 1) + ' 4'" :label-position="labelPosition" class="is-flex-grow-1"><b-input v-model="MOTSCLÉS_4"/></b-field>
                            <b-field v-bind:label="$tc('motcle', 1) + ' 5'" :label-position="labelPosition" class="is-flex-grow-1"><b-input v-model="MOTSCLÉS_5"/></b-field>
                        </b-field>
                        <b-field grouped>
                            <b-field v-bind:label="$tc('replique', 1) + ' 1'" :label-position="labelPosition" class="is-flex-grow-1"><b-input v-model="RÉPLIQUES_1"/></b-field>
                            <b-field v-bind:label="$tc('replique', 1) + ' 2'" :label-position="labelPosition" class="is-flex-grow-1"><b-input v-model="RÉPLIQUES_2"/></b-field>
                            <b-field v-bind:label="$tc('replique', 1) + ' 3'" :label-position="labelPosition" class="is-flex-grow-1"><b-input v-model="RÉPLIQUES_3"/></b-field>
                            <b-field v-bind:label="$tc('replique', 1) + ' 4'" :label-position="labelPosition" class="is-flex-grow-1"><b-input v-model="RÉPLIQUES_4"/></b-field>
                            <b-field v-bind:label="$tc('replique', 1) + ' 5'" :label-position="labelPosition" class="is-flex-grow-1"><b-input v-model="RÉPLIQUES_5"/></b-field>
                            <b-field v-bind:label="$tc('replique', 1) + ' 6'" :label-position="labelPosition" class="is-flex-grow-1"><b-input v-model="RÉPLIQUES_6"/></b-field>
                        </b-field>
                        <b-field grouped group-multiline>
                            <b-radio-button v-model="eveille" v-for="{name, desc, cost} in eveilles" @input="atoutCalc(cost)" :native-value="name" :name="name" :key="name" type="is-success is-light is-outlined">
                                <span>{{ name }} : {{ desc }}</span>
                            </b-radio-button>
                        </b-field>
                    </b-step-item>
                    <!-- STEP 3 METATYPE -->
                    <b-step-item step="3" v-bind:label="$t('step2')" :clickable="isStepsClickable">
                        <div class="columns is-centered">
                            <b-select v-bind:placeholder="$t('step2')" v-model="metatype" @input="metatypeCalc()">
                                <option v-for="metatype in metatypes" :value="metatype.name" :key="metatype.name">{{ $t(metatype.name) }}</option>
                            </b-select>
                        </div>
                    </b-step-item>
                    <!-- STEP 4 ATTRIBUTS -->
                    <b-step-item step="4" v-bind:label="$t('step3')" :clickable="isStepsClickable">
                        <div class="columns is-centered is-multiline">
                            <div class="column is-one-quarter">
                                <b-field position="is-centered" v-bind:label="$t('force')" :label-position="labelPosition"><b-numberinput v-model="force"       @input="typeCalc($event)" :min="minforce" :max="maxforce" :editable="false" controls-position="compact" controls-rounded expanded/></b-field>
                                <b-field position="is-centered" v-bind:label="$t('agilite')" :label-position="labelPosition"><b-numberinput v-model="agilite"   @input="typeCalc($event)" :min="minagilite" :max="maxagilite" :editable="false" controls-position="compact" controls-rounded expanded/></b-field>
                                <b-field position="is-centered" v-bind:label="$t('volonte')" :label-position="labelPosition"><b-numberinput v-model="volonte"   @input="typeCalc($event)" :min="minvolonte" :max="maxvolonte" :editable="false" controls-position="compact" controls-rounded expanded/></b-field>
                                <b-field position="is-centered" v-bind:label="$t('logique')" :label-position="labelPosition"><b-numberinput v-model="logique"   @input="typeCalc($event)" :min="minlogique" :max="maxlogique" :editable="false" controls-position="compact" controls-rounded expanded/></b-field>
                                <b-field position="is-centered" v-bind:label="$t('charisme')" :label-position="labelPosition"><b-numberinput v-model="charisme" @input="typeCalc($event)" :min="mincharisme" :max="maxcharisme" :editable="false" controls-position="compact" controls-rounded expanded/></b-field>
                                <b-field v-bind:label="$t('step3')" :label-position="labelPosition" :type="attributType"><b-input v-model="attributLeft" disabled rounded expanded/></b-field>
                            </div>
                        </div>
                    </b-step-item>
                    <!-- STEP 5 COMPÉTENCES -->
                    <b-step-item step="5" v-bind:label="$t('step4')" :clickable="isStepsClickable">
                        <div class="columns is-centered is-multiline">
                            <div class="column is-one-quarter">
                                <b-field position="is-centered">
                                    <b-select v-model="comp1_n"><optgroup v-for="group in competences" :key="group.key" :label="group.key"><option v-for="comp in group.listcomp" :key="comp.name" :value="comp.name">{{ comp.name }}</option></optgroup></b-select>
                                    <b-numberinput v-model="comp1_i" @input="typeCalc($event)" :min="1" :max="maxcomp" :editable="false" controls-position="compact" controls-rounded/>
                                </b-field>
                                <b-field position="is-centered">
                                    <b-select v-model="comp2_n"><optgroup v-for="group in competences" :key="group.key" :label="group.key"><option v-for="comp in group.listcomp" :key="comp.name" :value="comp.name">{{ comp.name }}</option></optgroup></b-select>
                                    <b-numberinput v-model="comp2_i" @input="typeCalc($event)" :min="1" :max="maxcomp" :editable="false" controls-position="compact" controls-rounded/>
                                </b-field>
                                <b-field position="is-centered">
                                    <b-select v-model="comp3_n"><optgroup v-for="group in competences" :key="group.key" :label="group.key"><option v-for="comp in group.listcomp" :key="comp.name" :value="comp.name">{{ comp.name }}</option></optgroup></b-select>
                                    <b-numberinput v-model="comp3_i" @input="typeCalc($event)" :min="1" :max="maxcomp" :editable="false" controls-position="compact" controls-rounded/>
                                </b-field>
                                <b-field position="is-centered">
                                    <b-select v-model="comp4_n"><optgroup v-for="group in competences" :key="group.key" :label="group.key"><option v-for="comp in group.listcomp" :key="comp.name" :value="comp.name">{{ comp.name }}</option></optgroup></b-select>
                                    <b-numberinput v-model="comp4_i" @input="typeCalc($event)" :min="1" :max="maxcomp" :editable="false" controls-position="compact" controls-rounded/>
                                </b-field>
                                <b-field position="is-centered">
                                    <b-select v-model="comp5_n"><optgroup v-for="group in competences" :key="group.key" :label="group.key"><option v-for="comp in group.listcomp" :key="comp.name" :value="comp.name">{{ comp.name }}</option></optgroup></b-select>
                                    <b-numberinput v-model="comp5_i" @input="typeCalc($event)" :min="1" :max="maxcomp" :editable="false" controls-position="compact" controls-rounded/>
                                </b-field>
                            </div>
                            <div class="column is-one-quarter">
                                <b-field position="is-centered"><b-checkbox v-model="comp1_check" :value="false"></b-checkbox><b-field label="Spécialisation" :label-position="labelPosition"><b-input v-model="comp1_s" rounded expanded/></b-field></b-field>
                                <b-field position="is-centered"><b-checkbox v-model="comp2_check" :value="false"></b-checkbox><b-field label="Spécialisation" :label-position="labelPosition"><b-input v-model="comp2_s" rounded expanded/></b-field></b-field>
                                <b-field position="is-centered"><b-checkbox v-model="comp3_check" :value="false"></b-checkbox><b-field label="Spécialisation" :label-position="labelPosition"><b-input v-model="comp3_s" rounded expanded/></b-field></b-field>
                                <b-field position="is-centered"><b-checkbox v-model="comp4_check" :value="false"></b-checkbox><b-field label="Spécialisation" :label-position="labelPosition"><b-input v-model="comp4_s" rounded expanded/></b-field></b-field>
                                <b-field position="is-centered"><b-checkbox v-model="comp5_check" :value="false"></b-checkbox><b-field label="Spécialisation" :label-position="labelPosition"><b-input v-model="comp5_s" rounded expanded/></b-field></b-field>
                            </div>
                        </div>
                        <div class="columns is-centered is-multiline">
                            <div class="column is-one-quarter">
                                <b-field v-bind:label="$t('step4')" :label-position="labelPosition" :type="competenceType"><b-input v-model="competenceLeft" disabled rounded expanded/></b-field>
                                <b-field v-bind:label="$tc('connaissance', 1)" :label-position="labelPosition"><b-input v-model="compConnaissance" rounded expanded/></b-field>
                            </div>
                        </div>
                    </b-step-item>
                    <!-- STEP 6 ATOUTS -->
                    <b-step-item step="6" v-bind:label="$t('step5')" :clickable="isStepsClickable">
                        <div class="columns is-centered">
                            <div class="column is-one-quarter">
                                <b-field position="is-centered" label="Nom" :label-position="labelPosition"><b-input v-model="atout1_n" rounded expanded/></b-field>
                                <b-field position="is-centered" label="Nom" :label-position="labelPosition"><b-input v-model="atout2_n" rounded expanded/></b-field>
                                <b-field position="is-centered" label="Nom" :label-position="labelPosition"><b-input v-model="atout3_n" rounded expanded/></b-field>
                                <b-field position="is-centered" label="Nom" :label-position="labelPosition"><b-input v-model="atout4_n" rounded expanded/></b-field>
                                <b-field position="is-centered" label="Nom" :label-position="labelPosition"><b-input v-model="atout5_n" rounded expanded/></b-field>
                                <b-field position="is-centered" label="Nom" :label-position="labelPosition"><b-input v-model="atout6_n" rounded expanded/></b-field>
                            </div>
                            <div class="column is-one-quarter">
                                <b-field position="is-centered" label="Description" :label-position="labelPosition"><b-input v-model="atout1_d" rounded expanded/></b-field>
                                <b-field position="is-centered" label="Description" :label-position="labelPosition"><b-input v-model="atout2_d" rounded expanded/></b-field>
                                <b-field position="is-centered" label="Description" :label-position="labelPosition"><b-input v-model="atout3_d" rounded expanded/></b-field>
                                <b-field position="is-centered" label="Description" :label-position="labelPosition"><b-input v-model="atout4_d" rounded expanded/></b-field>
                                <b-field position="is-centered" label="Description" :label-position="labelPosition"><b-input v-model="atout5_d" rounded expanded/></b-field>
                                <b-field position="is-centered" label="Description" :label-position="labelPosition"><b-input v-model="atout6_d" rounded expanded/></b-field>
                            </div>
                            <div class="column is-one-quarter">
                                <b-field grouped>
                                    <b-tooltip label="Coût en Atout"><b-numberinput v-model="atout1_i" @input="typeCalc($event)" :min="0" :max="5" :editable="false" controls-position="compact" controls-rounded expanded/></b-tooltip>
                                    <b-tooltip label="Coût en Essence"><b-numberinput v-model="atout1_e" @input="typeCalc($event)" :min="0" :max="5" :editable="false" controls-position="compact" step="0.5" controls-rounded expanded/></b-tooltip>
                                </b-field>
                                <b-field grouped>
                                    <b-tooltip label="Coût en Atout"><b-numberinput v-model="atout2_i" @input="typeCalc($event)" :min="0" :max="5" :editable="false" controls-position="compact" controls-rounded expanded/></b-tooltip>
                                    <b-tooltip label="Coût en Essence"><b-numberinput v-model="atout2_e" @input="typeCalc($event)" :min="0" :max="5" :editable="false" controls-position="compact" step="0.5" controls-rounded expanded/></b-tooltip>
                                </b-field>
                                <b-field grouped>
                                    <b-tooltip label="Coût en Atout"><b-numberinput v-model="atout3_i" @input="typeCalc($event)" :min="0" :max="5" :editable="false" controls-position="compact" controls-rounded expanded/></b-tooltip>
                                    <b-tooltip label="Coût en Essence"><b-numberinput v-model="atout3_e" @input="typeCalc($event)" :min="0" :max="5" :editable="false" controls-position="compact" step="0.5" controls-rounded expanded/></b-tooltip>
                                </b-field>
                                <b-field grouped>
                                    <b-tooltip label="Coût en Atout"><b-numberinput v-model="atout4_i" @input="typeCalc($event)" :min="0" :max="5" :editable="false" controls-position="compact" controls-rounded expanded/></b-tooltip>
                                    <b-tooltip label="Coût en Essence"><b-numberinput v-model="atout4_e" @input="typeCalc($event)" :min="0" :max="5" :editable="false" controls-position="compact" step="0.5" controls-rounded expanded/></b-tooltip>
                                </b-field>
                                <b-field grouped>
                                    <b-tooltip label="Coût en Atout"><b-numberinput v-model="atout5_i" @input="typeCalc($event)" :min="0" :max="5" :editable="false" controls-position="compact" controls-rounded expanded/></b-tooltip>
                                    <b-tooltip label="Coût en Essence"><b-numberinput v-model="atout5_e" @input="typeCalc($event)" :min="0" :max="5" :editable="false" controls-position="compact" step="0.5" controls-rounded expanded/></b-tooltip>
                                </b-field>
                                <b-field grouped>
                                    <b-tooltip label="Coût en Atout"><b-numberinput v-model="atout6_i" @input="typeCalc($event)" :min="0" :max="5" :editable="false" controls-position="compact" controls-rounded expanded/></b-tooltip>
                                    <b-tooltip label="Coût en Essence"><b-numberinput v-model="atout6_e" @input="typeCalc($event)" :min="0" :max="5" :editable="false" controls-position="compact" step="0.5" controls-rounded expanded/></b-tooltip>
                                </b-field>
                            </div>
                        </div>
                    </b-step-item>
                    <!-- STEP 7 TRAITS -->
                    <b-step-item step="7" v-bind:label="$t('step6')" :clickable="isStepsClickable">
                        <div class="columns is-centered is-multiline">
                            <div class="column is-one-quarter">
                                <b-field position="is-centered" label="Avantage 1" :label-position="labelPosition"><b-input v-model="trait1" rounded expanded/></b-field>
                                <b-field position="is-centered" label="Avantage 2" :label-position="labelPosition"><b-input v-model="trait2" rounded expanded/></b-field>
                                <b-field position="is-centered" label="Défaut" :label-position="labelPosition"><b-input v-model="defaut" rounded expanded/></b-field>
                            </div>
                            <div class="column is-one-quarter">
                                <b-field position="is-centered" label="Description" :label-position="labelPosition"><b-input v-model="trait1_2" rounded expanded/></b-field>
                                <b-field position="is-centered" label="Description" :label-position="labelPosition"><b-input v-model="trait2_2" rounded expanded/></b-field>
                                <b-field position="is-centered" label="Description" :label-position="labelPosition"><b-input v-model="defaut1_2" rounded expanded/></b-field>
                            </div>
                        </div>
                    </b-step-item>
                    <!-- STEP 8 CONTACTS -->
                    <b-step-item step="8" v-bind:label="$t('step7')" :clickable="isStepsClickable">
                        <div class="columns is-centered is-multiline">
                            <div class="column is-one-quarter">
                                <b-field position="is-centered" label="Contact 1" :label-position="labelPosition"><b-input v-model="contact1" rounded expanded/></b-field>
                                <b-field position="is-centered" label="Contact 2" :label-position="labelPosition"><b-input v-model="contact2" rounded expanded/></b-field>
                                <b-field position="is-centered" label="Contact 3" :label-position="labelPosition"><b-input v-model="contact3" rounded expanded/></b-field>
                                <b-field position="is-centered" label="Contact 4" :label-position="labelPosition"><b-input v-model="contact4" rounded expanded/></b-field>
                                <b-field position="is-centered" label="Contact 5" :label-position="labelPosition"><b-input v-model="contact5" rounded expanded/></b-field>
                                <b-field position="is-centered" label="Contact 6" :label-position="labelPosition"><b-input v-model="contact6" rounded expanded/></b-field>
                                <b-field position="is-centered" label="Contact 7" :label-position="labelPosition"><b-input v-model="contact7" rounded expanded/></b-field>
                                <b-field position="is-centered" label="Contact 8" :label-position="labelPosition"><b-input v-model="contact8" rounded expanded/></b-field>
                            </div>
                        </div>
                    </b-step-item>
                    <!-- STEP 9 ARMURE -->
                    <b-step-item step="9" v-bind:label="$t('step8')" :clickable="isStepsClickable">
                        <div class="columns is-centered">
                            <b-select v-bind:placeholder="$t('step8')" v-model="armureSelect" @input="armureCalc()">
                                <option v-for="armure in armures" :value="armure.indice" :key="armure.indice">{{ armure.name }}</option>
                            </b-select>
                        </div>
                    </b-step-item>
                    <!-- STEP 10 ARMES -->
                    <b-step-item step="10" v-bind:label="$t('step9')" :clickable="isStepsClickable">
                        <div class="columns is-centered">
                            <div class="column is-one-quarter">
                                <b-select v-model="arme1"><optgroup v-for="group in armes" :key="group.key" :label="group.key"><option v-for="arme in group.liste" :key="arme.name" :value="arme.name" v-on:click="armeCalc(1, group)">{{ arme.name }}</option></optgroup></b-select>
                                <b-select v-model="arme2"><optgroup v-for="group in armes" :key="group.key" :label="group.key"><option v-for="arme in group.liste" :key="arme.name" :value="arme.name" v-on:click="armeCalc(2, group)">{{ arme.name }}</option></optgroup></b-select>
                                <b-select v-model="arme3"><optgroup v-for="group in armes" :key="group.key" :label="group.key"><option v-for="arme in group.liste" :key="arme.name" :value="arme.name" v-on:click="armeCalc(3, group)">{{ arme.name }}</option></optgroup></b-select>
                                <b-select v-model="arme4"><optgroup v-for="group in armes" :key="group.key" :label="group.key"><option v-for="arme in group.liste" :key="arme.name" :value="arme.name" v-on:click="armeCalc(4, group)">{{ arme.name }}</option></optgroup></b-select>
                                <b-select v-model="arme5"><optgroup v-for="group in armes" :key="group.key" :label="group.key"><option v-for="arme in group.liste" :key="arme.name" :value="arme.name" v-on:click="armeCalc(5, group)">{{ arme.name }}</option></optgroup></b-select>
                            </div>
                        </div>
                    </b-step-item>
                    <!-- STEP 11 ÉQUIPEMENTS -->
                    <b-step-item step="11" v-bind:label="$t('step10')" :clickable="isStepsClickable">
                        <div class="columns is-centered is-multiline">
                            <div class="column is-one-quarter">
                                <b-field position="is-centered" label="Équipement 1" :label-position="labelPosition"><b-input v-model="equipement1" rounded expanded/></b-field>
                                <b-field position="is-centered" label="Équipement 2" :label-position="labelPosition"><b-input v-model="equipement2" rounded expanded/></b-field>
                                <b-field position="is-centered" label="Équipement 3" :label-position="labelPosition"><b-input v-model="equipement3" rounded expanded/></b-field>
                                <b-field position="is-centered" label="Équipement 4" :label-position="labelPosition"><b-input v-model="equipement4" rounded expanded/></b-field>
                                <b-field position="is-centered" label="Équipement 5" :label-position="labelPosition"><b-input v-model="equipement5" rounded expanded/></b-field>
                                <b-field position="is-centered" label="Équipement 6" :label-position="labelPosition"><b-input v-model="equipement6" rounded expanded/></b-field>
                                <b-field position="is-centered" label="Équipement 7" :label-position="labelPosition"><b-input v-model="equipement7" rounded expanded/></b-field>
                                <b-field position="is-centered" label="Équipement 8" :label-position="labelPosition"><b-input v-model="equipement8" rounded expanded/></b-field>
                            </div>
                        </div>
                    </b-step-item>
                    <b-step-item step="12" v-bind:label="$t('step11')" :clickable="isStepsClickable">
                        <div class="columns is-centered is-multiline"><b-button @click="pdfFill">Générer le PDF</b-button></div>
                    </b-step-item>
                    <template v-slot:navigation="{previous, next}">
                        <div class="field is-grouped is-grouped-centered">
                            <p class="control">
                                <a v-if="submitOk" class="button is-primary" v-on:click="next.action" :disabled="!submitOk">{{ $t('submit') }}</a>
                                <a v-else class="button is-primary is-white is-outlined" :disabled="true">{{ $t('submit') }}</a>
                            </p>
                            <p class="control">
                                <a v-if="cancelOk" class="button is-light" v-on:click="previous.action" :disabled="!cancelOk">{{ $t('cancel') }}</a>
                                <a v-else class="button is-light" :disabled="true">{{ $t('cancel') }}</a>
                            </p>
                            <p class="control">
                                <a class="button is-warning" v-on:click="refresh()">{{ $t('reset') }}</a>
                            </p>
                        </div>
                    </template>
                </b-steps>
                <div class="columns is-centered">
                    <div class="column is-two-fifths">
                        <div class="card">
                            <div class="card-header">
                                <p class="card-header-title">{{ $t('help_title') }}</p><span class="card-header-icon"><b-icon pack="fas" icon="info" type="is-primary" size="is-medium"></b-icon></span>
                            </div>
                            <div class="card-content" v-html="help"></div>
                        </div>
                    </div>
                </div>
                <div v-if="activeStep == 0">
                    <p class="">Le résultat final est un pdf pré-rempli </p>
                    <figure class="image is-64x64 is-vcentered">
                        <img alt="screenshot" src="../assets/screenshot.png">
                    </figure>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import metatypes from '../models/Métatypes.json';
    import eveilles from '../models/Éveillés.json';
    import competences from '../models/Compétences.json';
    import armures from '../models/Armures.json';
    import armes from '../models/Armes.json';
    import pdfform from 'pdfform.js';
    import { saveAs } from 'file-saver';
    export default {
        data() {
            return {
                //Styles
                labelPosition: 'on-border',
                activeStep: 0,
                isStepsClickable: false,
                
                //Listes
                metatypes: metatypes,
                eveilles: eveilles,
                competences: competences,
                armures: armures,
                armes: armes,
                
                //Points de création
                step0: 0,
                step2: 0,
                attributCount: 0,
                competenceCount: 0,
                atoutCount: 0,
                contactCount: 0,
                armeCount: 0,
                equipementCount: 0,
                competence: 1,
                maxcomp: 5,
                armure: 0,
                armureSelect: 0,
                
                //Personnages
                name: '',
                metatype: 'human',
                eveille: 'Non éveillé',
                is_eveille: false,
                is_emerge: false,
                MOTSCLÉS_1: '',
                MOTSCLÉS_2: '',
                MOTSCLÉS_3: '',
                MOTSCLÉS_4: '',
                MOTSCLÉS_5: '',
                RÉPLIQUES_1: '',
                RÉPLIQUES_2: '',
                RÉPLIQUES_3: '',
                RÉPLIQUES_4: '',
                RÉPLIQUES_5: '',
                RÉPLIQUES_6: '',
                COMPORTEMENTS_1: '',
                COMPORTEMENTS_2: '',
                COMPORTEMENTS_3: '',
                COMPORTEMENTS_4: '',
                
                //Caractéristiques
                force: 1,
                agilite: 1,
                volonte: 1,
                logique: 1,
                charisme: 1,
                chance: 2,
                minforce: 1,
                minagilite: 1,
                minvolonte: 1,
                minlogique: 1,
                mincharisme: 1,
                minchance: 1,
                maxforce: 6,
                maxagilite: 6,
                maxvolonte: 6,
                maxlogique: 6,
                maxcharisme: 6,
                maxchance: 7,
                
                //Compétences
                comp1_n: '',
                comp1_s: '',
                comp1_i: 0,
                comp1_check: false,
                comp2_n: '',
                comp2_s: '',
                comp2_i: 0,
                comp2_check: false,
                comp3_n: '',
                comp3_s: '',
                comp3_i: 0,
                comp3_check: false,
                comp4_n: '',
                comp4_s: '',
                comp4_i: 0,
                comp4_check: false,
                comp5_n: '',
                comp5_s: '',
                comp5_i: 0,
                comp5_check: false,
                compConnaissance: '',
                
                //Atouts
                atoutCost: 0,
                atout1_n: '',
                atout1_i: 0,
                atout1_d: '',
                atout1_e: 0,
                atout2_n: '',
                atout2_i: 0,
                atout2_d: '',
                atout2_e: 0,
                atout3_n: '',
                atout3_i: 0,
                atout3_d: '',
                atout3_e: 0,
                atout4_n: '',
                atout4_i: 0,
                atout4_d: '',
                atout4_e: 0,
                atout5_n: '',
                atout5_i: 0,
                atout5_d: '',
                atout5_e: 0,
                atout6_n: '',
                atout6_i: 0,
                atout6_d: '',
                atout6_e: 0,
                
                //Traits
                trait1: '',
                trait1_2: '',
                trait2: '',
                trait2_2: '',
                defaut: '',
                defaut1_2: '',
                
                //Contacts
                contact1: '',
                contact2: '',
                contact3: '',
                contact4: '',
                contact5: '',
                contact6: '',
                contact7: '',
                contact8: '',
                
                //Armes
                arme1: '',
                arme2: '',
                arme3: '',
                arme4: '',
                arme5: '',
                arme1vd: '',
                arme2vd: '',
                arme3vd: '',
                arme4vd: '',
                arme5vd: '',
                arme1p1: '',
                arme1p2: '',
                arme1p3: '',
                arme2p1: '',
                arme2p2: '',
                arme2p3: '',
                arme3p1: '',
                arme3p2: '',
                arme3p3: '',
                arme4p1: '',
                arme4p2: '',
                arme4p3: '',
                arme5p1: '',
                arme5p2: '',
                arme5p3: '',
                
                //Équipement
                equipement1: '',
                equipement2: '',
                equipement3: '',
                equipement4: '',
                equipement5: '',
                equipement6: '',
                equipement7: '',
                equipement8: '',
                
                //Finalisation
                motcleFinal: '',
                repliqueFinal: '',
                comportementFinal: '',
                attributFinal: '',
                competenceFinal: '',
                atoutFinal: '',
                contactFinal: '',
                armeFinal: '',
                equipementFinal: '',
                armureFinal: '',
            }
        },
        methods: {
            refresh: function () {
                document.location.reload();
            },
            countCalc: function(){
                this.attributType = 'is-info';
                this.competenceType = 'is-info';
                this.atoutType = 'is-info';
                this.contactType = 'is-info';
                this.armeType = 'is-info';
                this.equipementType = 'is-info';
                switch (this.step0){
                    case "1":
                        this.attributCount = 12;
                        this.attributLeft = 12;
                        this.competenceCount = 10 ;
                        this.competenceLeft = 10;
                        this.atoutCount = 6;
                        this.atoutLeft = 6;
                        this.contactCount = 1;
                        this.contactLeft = 1;
                        this.armeCount = 1;
                        this.armeLeft = 1;
                        this.equipementCount = 3;
                        this.equipementLeft = 3;
                    break;
                    case "2":
                        this.attributCount = 16;
                        this.attributLeft = 16;
                        this.competenceCount = 12;
                        this.competenceLeft = 12;
                        this.atoutCount = 10;
                        this.atoutLeft = 10;
                        this.contactCount = 2;
                        this.contactLeft = 2;
                        this.armeCount = 2;
                        this.armeLeft = 2;
                        this.equipementCount = 4;
                        this.equipementLeft = 4;
                    break;
                    case "3":
                        this.attributCount = 20;
                        this.attributLeft = 20;
                        this.competenceCount = 14;
                        this.competenceLeft = 14;
                        this.atoutCount = 14;
                        this.atoutLeft = 14;
                        this.contactCount = 3;
                        this.contactLeft = 3;
                        this.armeCount = 3;
                        this.armeLeft = 3;
                        this.equipementCount = 5;
                        this.equipementLeft = 5;
                        this.maxcomp = 6;
                    break;
                }
            },
            typeCalc: function(){
                if(this.attributLeft === 0)
                    this.attributType = 'is-warning';
                if(this.competenceLeft === 0)
                    this.competenceType = 'is-warning';
                if(this.atoutLeft === 0)
                    this.atoutType = 'is-warning';
                if(this.contactLeft === 0)
                    this.contactType = 'is-warning';
                if(this.armeLeft === 0)
                    this.armeType = 'is-warning';
                if(this.equipementLeft === 0)
                    this.equipementType = 'is-warning';
            },
            atoutCalc: function(cost){
                this.atoutCost = cost;
                this.is_emerge = this.eveille === 'Émergé';
                this.is_eveille = this.eveille !== 'Émergé' && this.eveille !== 'Non éveillé';
            },
            metatypeCalc: function(){
                switch (this.metatype) {
                    case 'human':
                        this.force = 1;
                        this.agilite = 1;
                        this.volonte = 1;
                        this.charisme = 1;
                        this.chance = 2;
                        this.competence = 1;
                        this.armure = 0;
                        this.minforce = 1;
                        this.minagilite = 1;
                        this.minvolonte = 1;
                        this.mincharisme = 1;
                        this.minchance = 2;
                        this.maxforce = 6;
                        this.maxagilite = 6;
                        this.maxvolonte = 6;
                        this.maxlogique = 6;
                        this.maxcharisme = 6;
                        this.maxchance = 7;
                    break;
                    case 'elf':
                        this.force = 1;
                        this.agilite = 2;
                        this.volonte = 1;
                        this.charisme = 2;
                        this.chance = 1;
                        this.competence = 0;
                        this.armure = 0;
                        this.minforce = 1;
                        this.minagilite = 2;
                        this.minvolonte = 1;
                        this.mincharisme = 2;
                        this.minchance = 1;
                        this.maxforce = 6;
                        this.maxagilite = 7;
                        this.maxvolonte = 6;
                        this.maxlogique = 6;
                        this.maxcharisme = 8;
                        this.maxchance = 6;
                    break;
                    case 'dwarf':
                        this.force = 2;
                        this.agilite = 1;
                        this.volonte = 2;
                        this.charisme = 1;
                        this.chance = 1;
                        this.competence = 0;
                        this.armure = 0;
                        this.minforce = 2;
                        this.minagilite = 1;
                        this.minvolonte = 2;
                        this.mincharisme = 1;
                        this.minchance = 1;
                        this.maxforce = 8;
                        this.maxagilite = 6;
                        this.maxvolonte = 7;
                        this.maxlogique = 6;
                        this.maxcharisme = 6;
                        this.maxchance = 6;
                    break;
                    case 'ork':
                        this.force = 3;
                        this.agilite = 1;
                        this.volonte = 1;
                        this.charisme = 1;
                        this.chance = 1;
                        this.competence = 0;
                        this.armure = 0;
                        this.minforce = 3;
                        this.minagilite = 1;
                        this.minvolonte = 1;
                        this.mincharisme = 1;
                        this.minchance = 1;
                        this.maxforce = 8;
                        this.maxagilite = 6;
                        this.maxvolonte = 6;
                        this.maxlogique = 6;
                        this.maxcharisme = 5;
                        this.maxchance = 6;
                    break;
                    case 'troll':
                        this.force = 3;
                        this.agilite = 1;
                        this.volonte = 1;
                        this.charisme = 1;
                        this.chance = 1;
                        this.competence = -1;
                        this.armure = 3;
                        this.minforce = 3;
                        this.minagilite = 1;
                        this.minvolonte = 1;
                        this.mincharisme = 1;
                        this.minchance = 1;
                        this.maxforce = 10;
                        this.maxagilite = 5;
                        this.maxvolonte = 6;
                        this.maxlogique = 5;
                        this.maxcharisme = 4;
                        this.maxchance = 6;
                    break;
                }
            },
            armureCalc: function(){
                switch (this.armureSelect) {
                    case 6:
                        this.armureFinal = 'Le choix d\'armure donne 1 point de compétence à redistribuer.<br/>';
                    break;
                    case 12:
                        this.armureFinal = 'Le choix d\'armure oblige à retirer 1 point de compétence.<br/>';
                    break;
                }
            },
            armeCalc: function(key, group){
                switch (key) {
                    case 1:
                        this.arme1vd = group.vd;
                        this.arme1p1 = group.courte;
                        this.arme1p2 = group.int;
                        this.arme1p3 = group.longue;
                    break;
                    case 2:
                        this.arme2vd = group.vd;
                        this.arme2p1 = group.courte;
                        this.arme2p2 = group.int;
                        this.arme2p3 = group.longue;
                    break;
                    case 3:
                        this.arme3vd = group.vd;
                        this.arme3p1 = group.courte;
                        this.arme3p2 = group.int;
                        this.arme3p3 = group.longue;
                    break;
                    case 4:
                        this.arme4vd = group.vd;
                        this.arme4p1 = group.courte;
                        this.arme4p2 = group.int;
                        this.arme4p3 = group.longue;
                    break;
                    case 5:
                        this.arme5vd = group.vd;
                        this.arme5p1 = group.courte;
                        this.arme5p2 = group.int;
                        this.arme5p3 = group.longue;
                    break;
                }
            },
            pdfFill: async function (){
                const loadingComponent = this.$buefy.loading.open({container: null});
                setTimeout(() => loadingComponent.close(), 3 * 1000);
                var buf = await fetch("./template.pdf").then(d=>d.arrayBuffer());
                
                var fields = {
                    'nom': [this.name],
                    'force': [this.force],
                    'agilite': [this.agilite],
                    'volonte': [this.volonte],
                    'logique': [this.logique],
                    'charisme': [this.charisme],
                    'chance': [this.chance],
                    'MOTSCLÉS 1': [this.MOTSCLÉS_1],
                    'MOTSCLÉS 2': [this.MOTSCLÉS_2],
                    'MOTSCLÉS 3': [this.MOTSCLÉS_3],
                    'MOTSCLÉS 4': [this.MOTSCLÉS_4],
                    'MOTSCLÉS 5': [this.MOTSCLÉS_5],
                    'RÉPLIQUES 1': [this.RÉPLIQUES_1],
                    'RÉPLIQUES 2': [this.RÉPLIQUES_2],
                    'RÉPLIQUES 3': [this.RÉPLIQUES_3],
                    'RÉPLIQUES 4': [this.RÉPLIQUES_4],
                    'RÉPLIQUES 5': [this.RÉPLIQUES_5],
                    'RÉPLIQUES 6': [this.RÉPLIQUES_6],
                    'COMPORTEMENTS 1': [this.COMPORTEMENTS_1],
                    'COMPORTEMENTS 2': [this.COMPORTEMENTS_2],
                    'COMPORTEMENTS 3': [this.COMPORTEMENTS_3],
                    'COMPORTEMENTS 4': [this.COMPORTEMENTS_4],
                    'comp1': [this.comp1_n],
                    'comp1-2': [this.comp1_i],
                    'comp1-spe': [this.comp1_s],
                    'comp2': [this.comp2_n],
                    'comp2-2': [this.comp2_i],
                    'comp2-spe': [this.comp2_s],
                    'comp3': [this.comp3_n],
                    'comp3-2': [this.comp3_i],
                    'comp3-spe': [this.comp3_s],
                    'comp4': [this.comp4_n],
                    'comp4-2': [this.comp4_i],
                    'comp4-spe': [this.comp4_s],
                    'comp5': [this.comp5_n],
                    'comp5-2': [this.comp5_i],
                    'comp5-spe': [this.comp5_s],
                    'comp9': [this.compConnaissance],
                    'comp9-2': ['(C)'],
                    
                    'atout1': [this.atout1_n],
                    'atout1-2': [this.atout1_d],
                    'niv_atout': [this.atout1_i],
                    'atout2': [this.atout2_n],
                    'atout2-2': [this.atout2_d],
                    'niv_atout2': [this.atout2_i],
                    'atout3': [this.atout3_n],
                    'atout3-2': [this.atout3_d],
                    'niv_atout3': [this.atout3_i],
                    'atout4': [this.atout4_n],
                    'atout4-2': [this.atout4_d],
                    'niv_atout4': [this.atout4_i],
                    'atout5': [this.atout5_n],
                    'atout5-2': [this.atout5_d],
                    'niv_atout5': [this.atout5_i],
                    'atout6': [this.atout6_n],
                    'atout6-2': [this.atout6_d],
                    'niv_atout6': [this.atout6_i],
                    'essence': [this.essenceLeft],
                    'essence_malus': [this.essence_malus],
                    
                    'trait1': [this.trait1],
                    'trait1-2': [this.trait1_2],
                    'trait2': [this.trait2],
                    'trait2-2': [this.trait2_2],
                    'defaut': [this.defaut],
                    'defaut1-2': [this.defaut1_2],
                    
                    'contact1': [this.contact1],
                    'contact2': [this.contact2],
                    'contact3': [this.contact3],
                    'contact4': [this.contact4],
                    'CONTACT_V': [this.contact5],
                    'CONTACT_V2': [this.contact6],
                    'CONTACT_V3': [this.contact7],
                    'CONTACT_V4': [this.contact8],
                    
                    'arme1': [this.arme1],
                    'arme2': [this.arme2],
                    'arme3': [this.arme3],
                    'arme4': [this.arme4],
                    'arme5': [this.arme5],
                    'VD1': [this.arme1vd],
                    'VD2': [this.arme2vd],
                    'VD3': [this.arme3vd],
                    'VD4': [this.arme4vd],
                    'VD5': [this.arme5vd],
                    'courte1': [this.arme1p1],
                    'courte2': [this.arme2p1],
                    'courte3': [this.arme3p1],
                    'courte4': [this.arme4p1],
                    'courte5': [this.arme5p1],
                    'int1': [this.arme1p2],
                    'int2': [this.arme2p2],
                    'int3': [this.arme3p2],
                    'int4': [this.arme4p2],
                    'int5': [this.arme5p2],
                    'longue1': [this.arme1p3],
                    'longue2': [this.arme2p3],
                    'longue3': [this.arme3p3],
                    'longue4': [this.arme4p3],
                    'longue5': [this.arme5p3],
                    
                    
                    'equipement1': [this.equipement1],
                    'equipement2': [this.equipement2],
                    'equipement3': [this.equipement3],
                    'EQUIP_V': [this.equipement4],
                    'EQUIP_V2': [this.equipement5],
                    'EQUIP_V3': [this.equipement6],
                    'EQUIP_V4': [this.equipement7],
                    'EQUIP_V5': [this.equipement8],
                    
                    'emerge': [this.is_emerge],
                    'eveille': [this.is_eveille]
                };
                
                var filled_pdf; // Uint8Array
                //var list = pdfform().list_fields(buf);
                //console.log(list);
                filled_pdf = pdfform().transform(buf, fields);
                var blob = new Blob([filled_pdf], {type: 'application/pdf'});
                saveAs(blob, 'pdfform.js_generated.pdf');
                this.$buefy.toast.open({
                    message: this.$t('export_success'),
                    type: 'is-success'
                })
            }
        },
        computed: {
            attributLeft: {
                get(){
                    let min = this.minforce + this.minagilite + this.minvolonte + this.minlogique + this.mincharisme;
                    let total = this.force + this.agilite + this.volonte + this.logique + this.charisme;
                    return this.attributCount - total + min;
                },
                set(val){ return val; }
            },
            competenceLeft: {
                get(){
                    let spe = (this.comp1_check ? 1 : 0) + (this.comp2_check ? 1 : 0) + (this.comp3_check ? 1 : 0) + (this.comp4_check ? 1 : 0) + (this.comp5_check ? 1 : 0);
                    let total = this.comp1_i + this.comp2_i + this.comp3_i + this.comp4_i + this.comp5_i;
                    return this.competenceCount - total - spe + this.competence;
                },
                set(val){ return val; }
            },
            atoutLeft: {
                get(){
                    let total = this.atoutCost + this.atout1_i + this.atout2_i + this.atout3_i + this.atout4_i + this.atout5_i + this.atout6_i;
                    return this.atoutCount - total;
                },
                set(val){ return val; }
            },
            essenceLeft: {
                get(){
                    let essence = this.atout1_e + this.atout2_e + this.atout3_e + this.atout4_e + this.atout5_e + this.atout6_e;
                    return 6 - essence;
                },
                set(val){ return val; }
            },
            essence_malus: {
                get(){
                    let val = '';
                    let e = this.essenceLeft;
                    if(e <= 1)
                        val = '-3 dés pour les soins, magie et résonance';
                    else if(e <= 3 && e >= 1.5)
                        val = '-2 dés pour les soins, magie et résonance';
                    else if(e <= 5 && e >= 3.5)
                        val = '-1 dé pour les soins, magie et résonance';
                    else if(e >= 5.5)
                        val = 'aucun malus';
                    return val;
                },
                set(val){ return val; }
            },
            contactLeft: {
                get(){
                    let total = 0;//this.atout1_i + this.atout2_i + this.atout3_i + this.atout4_i + this.atout5_i + this.atout6_i;
                    return this.contactCount - total;
                },
                set(val){ return val; }
            },
            armeLeft: {
                get(){
                    let total = 0;//this.arme1_i + this.atout2_i + this.atout3_i + this.atout4_i + this.atout5_i + this.atout6_i;
                    return this.armeCount - total;
                },
                set(val){ return val; }
            },
            equipementLeft: {
                get(){
                    let total = 0;//this.atout1_i + this.atout2_i + this.atout3_i + this.atout4_i + this.atout5_i + this.atout6_i;
                    return this.equipementCount - total;
                },
                set(val){ return val; }
            },
            attributType: {
                get(){ return this.attributLeft < 0 ? 'is-warning' : 'is-info'; },
                set(val){ return val; }
            },
            competenceType: {
                get(){ return this.competenceLeft < 0 ? 'is-warning' : 'is-info'; },
                set(val){ return val; }
            },
            atoutType: {
                get(){ return this.atoutLeft < 0 ? 'is-warning' : 'is-info'; },
                set(val){ return val; }
            },
            essenceType: {
                get(){ return this.essenceLeft < 0.5 ? 'is-danger' : 'is-info'; },
                set(val){ return val; }
            },
            contactType: {
                get(){ return this.contactLeft < 0 ? 'is-warning' : 'is-info'; },
                set(val){ return val; }
            },
            armeType: {
                get(){ return this.armeLeft < 0 ? 'is-warning' : 'is-info'; },
                set(val){ return val; }
            },
            equipementType: {
                get(){ return this.equipementLeft < 0 ? 'is-warning' : 'is-info'; },
                set(val){ return val; }
            },
            submitOk: function () {
                return this.step0 !== 0;
            },
            cancelOk: function(){
                return this.activeStep > 0;
            },
            help: function(){//Actualisation zone d'aide
                if(this.activeStep === 11){
                    let attribut = this.attributLeft !== 0 ? "Les points d'Attributs restant sont de " + this.attributLeft +".<br/>" : "";
                    let comp = this.competenceLeft !== 0 ? "Les points de compétences restant sont de " + this.competenceLeft +".<br/>" : "";
                    let atout = this.atoutLeft !== 0 ? "Les points d'Atouts restant sont de " + this.atoutLeft +".<br/>" : "";
                    return this.$t('help_step11') + attribut + comp + atout + this.armureFinal;
                }
                /*motcleFinal: '',
                repliqueFinal: '',
                comportementFinal: '',
                contactFinal: '',
                armeFinal: '',
                equipementFinal: '',
                armureFinal: '',*/
                return this.$t('help_step' + this.activeStep);
            },
        }
    }
</script>

<style>
    .bg-yellow{
        background-color: #e5b716;
    }
    .bg-gray{
        background-image: url(../assets/bg.png);
        background-color: #d3d4d8;
    }
    .bg-black{
        background-color: #302e2d;
    }
    .minh500{
        min-height: 500px;
    }
    .minh300{
        min-height: 300px;
    }
</style>